import { getGameInvites } from "./pendingGames"

const NEW_GAME_FORM_ID = "new-game-form"
const NEW_GAME_BUTTON_ID = "create-new-game"
const EMAIL_INPUT_CONTAINER_CLASS = "input-email-address-container"
const ADD_EMAIL_CLASS = "add-new-email"
const REMOVE_EMAIL_CLASS = "remove-email"
const EMAIL_INPUT_CLASS = "input-email-address"
const NEW_GAME_ERROR_ID = "new-game-error"
const NEW_GAME_SUCCESS_ID = "new-game-success"

export function registerClickHandlers() {
  // Register create new game button handler
  const createNewGameBtn = document.getElementById(NEW_GAME_BUTTON_ID)
  const newGameForm = document.getElementById(NEW_GAME_FORM_ID)
  createNewGameBtn.onclick = createGameClickHandler

  const emailContainerPrimary = newGameForm.getElementsByClassName(EMAIL_INPUT_CONTAINER_CLASS)[0]
  const addEmailIcon = emailContainerPrimary.getElementsByClassName(ADD_EMAIL_CLASS)[0]
  addEmailIcon.onclick = addNewEmailClickHandler
  const removeEmailIcon = emailContainerPrimary.getElementsByClassName(REMOVE_EMAIL_CLASS)[0]
  removeEmailIcon.onclick = getRemoveEmailClickHandler(emailContainerPrimary)
}

function addNewEmailClickHandler(e) {
  const newGameForm = document.getElementById(NEW_GAME_FORM_ID)
  const allEmailContainers = newGameForm.getElementsByClassName(EMAIL_INPUT_CONTAINER_CLASS)
  if (allEmailContainers.length < 5) {
    addEmailInput()
  }
}

function getRemoveEmailClickHandler(emailContainer) {
  return function (e) {
    const newGameForm = document.getElementById(NEW_GAME_FORM_ID)
    const allEmailContainers = newGameForm.getElementsByClassName(EMAIL_INPUT_CONTAINER_CLASS)
    if (allEmailContainers.length > 1) {
      emailContainer.remove()
    }
  }
}

function addEmailInput() {
  const newGameForm = document.getElementById(NEW_GAME_FORM_ID)
  const allEmailContainers = newGameForm.getElementsByClassName(EMAIL_INPUT_CONTAINER_CLASS)
  const firstEmailContainer = allEmailContainers[0]
  const newEmailContainer = firstEmailContainer.cloneNode(true)
  newEmailContainer.getElementsByClassName(EMAIL_INPUT_CLASS)[0].value = ""
  firstEmailContainer.parentElement.appendChild(newEmailContainer)
  const addEmailIcon = newEmailContainer.getElementsByClassName(ADD_EMAIL_CLASS)[0]
  addEmailIcon.onclick = addNewEmailClickHandler
  const removeEmailIcon = newEmailContainer.getElementsByClassName(REMOVE_EMAIL_CLASS)[0]
  removeEmailIcon.onclick = getRemoveEmailClickHandler(newEmailContainer)
}

async function createGameClickHandler(e) {
  e.preventDefault()
  const errorMessage = document.getElementById(NEW_GAME_ERROR_ID)
  errorMessage.hidden = true
  const successMessage = document.getElementById(NEW_GAME_SUCCESS_ID)
  successMessage.hidden = true
  if (!ID.user) {
    return;
  }
  const newGameForm = document.getElementById(NEW_GAME_FORM_ID)
  const emailAddressesElements = newGameForm.getElementsByClassName(EMAIL_INPUT_CLASS)
  const emailAddresses = [...emailAddressesElements].map((el) => el.value).filter(value => /\S/.test(value));
  try {
    const response = await fetch("/.netlify/functions/createGameInvite", {
      method: 'POST',
      headers: {
        authorization: `Bearer ${ID.user.getAuthResponse().id_token}`
      },
      body: JSON.stringify({
        emailAddresses
      })
    })
    const responseBody = await response.json();
    if (!response.ok) {
      errorMessage.textContent = responseBody.msg
      errorMessage.hidden = false
      return
    }

    successMessage.hidden = false
    successMessage.textContent = `Game invitation created with ${responseBody.invited.join(", ")}`
    getGameInvites()
  }
  catch (err) {
    console.error(err)
  }
}